import "./index.css";
import { EditFilled, QuestionCircleFilled } from "@ant-design/icons";
import { LinkSpan } from "../linkSpan";

const AppHeaderLink = () => {
  return (
    <div className={"appHeaderLink"}>
      <div className={"appHeaderLinkItem"}>
        <EditFilled className={"headerIcon"} />
        <LinkSpan
          className={"headerFontStyle"}
          text={"Feedback"}
          target="_blank"
          to={{
            pathname:
              "https://docs.google.com/forms/d/1BugnXcoB_O9r8MXWWVf6dopL1Y9szRfCX5u33vCyAmU/edit",
          }}
          matomoContext="appHeader"
          keyId={"feedbackId"}
        />
      </div>
      <div className={"appHeaderLinkItem"}>
        <QuestionCircleFilled className={"headerIcon"} />
        <LinkSpan
          className={"headerFontStyle"}
          text={"Help"}
          target="_blank"
          to={{
            pathname:
              "https://docs.google.com/document/d/1v_e0txtXbXFR5HiGskpksnTJnVDOltBzOi4xZWKO1yU/edit#heading=h.wtr6p39hbyog",
          }}
          matomoContext="appHeader"
          keyId={"helpId"}
        />
      </div>
    </div>
  );
};

export default AppHeaderLink;
